import { Component, Input, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
import { CommonService } from 'fccore2';
import { NzTreeNode, NzFormatEmitEvent } from 'ng-zorro-antd';
import { FctreeBusiness } from '../business/fctree.business';
/**
 * fc-treeæ æ§ä»¶
 * æ å½¢æ§ä»¶ã
 * æä»¶å¤¹ãç»ç»æ¶æãçç©åç±»ãå½å®¶å°åºç­ç­ï¼ä¸é´ä¸ç©çå¤§å¤æ°ç»æé½æ¯æ å½¢ç»æãä½¿ç¨æ æ§ä»¶å¯ä»¥å®æ´å±ç°å¶ä¸­çå±çº§å³ç³»ï¼å¹¶å·æå±å¼æ¶èµ·éæ©ç­äº¤äºåè½ã
 */
@Component({
    selector: 'fc-tree',
    template: `<div *ngIf="!fcNodes||fcNodes.length==0" style="text-align:center" >ææ æ°æ®</div>
                <nz-tree #fcRef *ngIf="fcNodes&&fcNodes.length>0"
                [nzData]="fcNodes"
                [nzCheckable]="fcOption.fcCheckable"
                [nzMultiple]="fcOption.fcMutliple"
                [nzAsyncData]="fcOption.fcAsync"
                (nzExpandChange)="getChildren('expand',$event)"
                [nzExpandedKeys]="fcExpandKeys"
                [nzCheckedKeys]="fcCheckedKeys"
                [nzSelectedKeys]="fcSelectedKeys"
                [nzExpandAll]="fcOption.fcOpenChild"
                (nzClick)="event('click',$event)"
                (nzDblClick)="event('dblclick', $event)"
                (nzContextMenu)="event('rightclick', $event)"
                (nzCheckBoxChange)="checkChange('checkChange', $event)"
                (nzSearchValueChange)="event('search', $event)"
                [nzDraggable]="fcOption.fcAllowDrag"
                [nzBeforeDrop]="beforeDrop"
                (nzOnDragStart)="event('dragstart',$event)"
                (nzOnDragEnter)="event('enter',$event)"
                (nzOnDragLeave)="event('leave', $event)"
                (nzOnDrop)="event('drop', $event)"
                (nzOnDragEnd)="event('end', $event)">
            </nz-tree>`,
    styles: [`
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FctreeComponent),
        multi: true
    }]
})
export class FctreeComponent extends FcinputComponent {
    @Input()
    /** éä¸­çèç¹åå®¹IDå¼ */
    fcId: string;
    @Input()
    fcNodes: any[];
    /** éç½® */
    @Input()
    fcOption: TreeOptions;
    @Input()
    fcSelectedKeys: string[];
    @Input()
    fcExpandKeys: string[];
    @Input()
    fcCheckedKeys: string[];
    beforeDrop: any;
    /**  å¼æ­¥åæ° */
    _options = {
        allowDrag: false,
        getChildren: (node: any) => {
            let data = node.DATA;
            if (data === undefined) {
                data = node.data.DATA;
            }
            const obsv = this.appService.findWithQuery(this.fcAppid, {
                WHERE: CommonService.getStringFilterByParam(data, this.fcOption.fcExpWhere),
                ORDER: this.fcOption.fcOrderby
            });
            return new Promise((resolve, reject) => {
                this.pushDestroy(obsv.subscribe((result) => resolve(this._listtotreeasync(result.DATA, this.fcOption.fcChildCode,
                    this.fcOption.fcLabel, this.fcOption.fcParentCode, this.fcOption.fcLeafCode))));
            });
        }
    };
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-tree');
    }
    ngOnChanges(param): void {
        if (this.fcOption === undefined) {
            new Error('ç¼ºå°fcOptionå±æ§');
        }
        if (this.fcOption.fcAllowDrag) {
            this._options.allowDrag = this.fcOption.fcAllowDrag;
        }
        if (this.fcNodes === undefined || this.fcOption.fcRefresh === true) {
            this.fcNodes = [];
            this.fcAppid = this.fcOption.fcAppid;
            this.pushDestroy(this.daoService.getFromApi(this.fcUrl,
                Object.assign({}, { AID: this.fcAppid }, {
                    ORDER: this.fcOption.fcOrderby || '',
                    WHERE: this.fcOption.fcTopWhere
                }, this.fcRequestParam)).subscribe(result => {
                    if (result.CODE === '0' && result.DATA.length !== 0) {
                        this.fcNodes = this._listtotreeasync(result.DATA,
                            this.fcOption.fcChildCode, this.fcOption.fcLabel, this.fcOption.fcParentCode, this.fcOption.fcLeafCode);
                        //  //console.log(this.fcNodes);
                        this.event('loadedDataSuccess', this.fcNodes);
                    } else {
                        this.fcNodes = undefined;
                        this.event('loadedDataFail', this.fcNodes);
                    }
                }));
        }
    }
    /**
     * éä¸­çæ¹å
     * @param eventName äºä»¶åç§°
     * @param param äºä»¶åæ°
     */
    checkChange(eventName, param) {
        param.selectedKeys = FctreeBusiness.getSelectedKey(this, this.fcRef.getCheckedNodeList()).replace(',,', ',');
        param.selectedParentKeys = FctreeBusiness.getParentNodeKeys(param.checkedKeys).replace(',,', ',');
        super.event(eventName, param);
    }
    /**
     * å¨å­èç¹ä¸­è·åä¸çº§èç¹
     * @param node å½åå­èç¹
     */
    getChildren(event, node: NzFormatEmitEvent) {
        const data = node.node.origin.DATA;
        if (this.fcAppid !== undefined && this.fcAppid.length !== 0) {
            this.pushDestroy(this.appService.findWithQuery(this.fcAppid, {
                WHERE: CommonService.getJsonStrFilterByParam(data, this.fcOption.fcExpWhere, '#'),
                ORDER: this.fcOption.fcOrderby
            }).subscribe(result => {
                if (result.CODE === '0') {
                    if (node.node && node.node.children && node.node.children.length > 0) {
                        node.node.clearChildren();
                    }
                    node.node.addChildren(this._listtotreeasync(result.DATA, this.fcOption.fcChildCode,
                        this.fcOption.fcLabel, this.fcOption.fcParentCode, this.fcOption.fcLeafCode));
                }
                this.event('expand', node);
            }));
        } else {
            this.event('expand', node);
        }
    }

    /**
     *
     * @description æ°ç»è½¬æ ç»æ
     * @param id idå¼
     * @param list æ°æ®åè¡¨
     * @param parentValue ä¸çº§ç¼ç çå¼
     * @param code ç¼ç 
     * @param name åç§°
     * @param subtitle å°æ é¢
     * @param parent ç¶çº§ç¼ç å­æ®µ
     * @param childFieldCode æ¯å¦æå­èç¹çåç§°
     * @param lastValue æ¯å¦ä½ä¸ºå¤æ­æ¯å¦æ¯å¶å­èç¹
     */
    private _listtotreeasync(list: any[], code: string, name: string, parent: string, childFieldCode: string): any[] {
        const nodes: any[] = [];
        list.forEach(item => {
            const node: any = {
                title: CommonService.getJsonStrFilterByParam(item, name, '#'),
                key: item[code],
                DATA: item
            };
            if (this.fcOption.fcLeafValue === undefined) { /** å¶å­èç¹çå¼æ¯éè¿æ­¤å¼è¿è¡å¤æ­æ¯å¦æ¯å¶å­æèæ¯å¦æ¯æ«çº§ */
                this.fcOption.fcLeafValue = 'Y';
            }
            if (item[this.fcOption.fcLeafCode] !== this.fcOption.fcLeafValue) {
                node.isLeaf = true;
            }
            /** æ ¡éªæ¯å¦éä¸­ */
            if (this.fcOption.fcCheckable && this.fcCheckedKeys) {
                const checkkeys = this.fcCheckedKeys.filter(key => key === item[code]);
                if (checkkeys.length > 0) {
                    node.checked = true;
                }
            }
            nodes.push(new NzTreeNode(node));
        });
        return nodes;
    }
}
export interface TreeOptions {
    /** åæ°æ®id */
    fcAppid: string; /** åæ°æ®id */
    /** æ ç»æèç¹æ¾ç¤ºåå®¹ */
    fcLabel: string; /** æ¯æ#{åæ°åç§°}# #{NAME}#:#{CODE}# */
    /** å³èç¶èç¹å­æ®µåç§° */
    fcParentCode: string; /** 'PARENT', */
    /** å½åèç¹å­æ®µåç§° */
    fcChildCode: string; /** 'CODE', */
    /** å¶å­èç¹å­æ®µåç§° */
    fcLeafCode: string; /** 'ISLAST', */
    /** æ ¹èç¹æ¡ä»¶ */
    fcTopWhere: string; /** "{or:[{parent:{IS:''}},{parent:{eq:''}}]}", */
    /** å±å¼æ¡ä»¶ */
    fcExpWhere: string; /** "{PARENT:{eq:'#{MENUID}#'}}", */
    /** æåºå­æ®µ */
    fcOrderby: string;
    /** æ¨¡å¼ */
    fcMode: boolean;
    /** å±å¼å­èç¹ */
    fcOpenChild: boolean;
    /** å±å¼å­èç¹ */
    fcCheckable?: boolean;
    /** æ¯å¦å¤é */
    fcMutliple?: boolean;
    /** æ¯å¦æ¾ç¤ºçº¿ */
    fcShowLine: boolean;
    /** å¯å¦ææ½ */
    fcAllowDrag: boolean;
    /** å¶å­èç¹çå¼æ¯éè¿æ­¤å¼è¿è¡å¤æ­æ¯å¦æ¯å¶å­æèæ¯å¦æ¯æ«çº§ */
    fcLeafValue?: string;
    /** é»è®¤å¼æ­¥å è½½ä¸ºfalse */
    fcAsync?: boolean;
    /** æ¯å¦éæ°å è½½ */
    fcRefresh?: boolean;
}

